import React from "react";
import { Button, Table } from "antd";
import { UserLink } from "../../../components/UserLink/UserLink";

export const UserListPanel = ({ members, onSelect, selectText }) => {
  const columns = [
    {
      title: "Salutation",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Full name",
      dataIndex: ["name"],
      key: "name",
      render: (_, r) => <UserLink userId={r.id} name={r.name} />,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      key: "opt",
      render: (_, r) => (
        <Button size="small" onClick={() => onSelect && onSelect(r)}>
          {selectText}
        </Button>
      ),
    },
  ];

  return <Table size="small" rowKey="id" columns={columns} dataSource={members} />;
};
